import PropTypes from "prop-types";
import "./CreditCardPaymentType.scss";
import { FormattedDate, FormattedMessage } from "react-intl";
import { Amount } from "app/components/ui/Amount/Amount";
import CreditCardMarketingBannerContainer from "app/pages/Booking/Payment/CreditCardMarketingBanner/CreditCardMarketingBannerContainer";
import CreditCardFieldsetContainer from "app/pages/Booking/Payment/CreditCardFieldset/CreditCardFieldsetContainer";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const CreditCardPaymentType = ({
	payNowAmount,
	payLaterAmount,
	dueDate,
	onCreditCardInputsBlur,
	onAdyenComponentMounted = () => {},
	onCreditCardSubmit = () => {},
	onAdyenAdditionalDetails = () => {},
	isAdyenFlow,
	showAmountToPay,
}) => {
	return (
		<div className="creditcard-payment-type">
			<div className="creditcard-payment-type__marketing">
				<CreditCardMarketingBannerContainer />
			</div>
			<Typography
				variant={TYPOGRAPHY_VARIANTS.REGULAR}
				isBold
				className="creditcard-payment-type__pay-amount"
			>
				{payLaterAmount > 0 ? (
					<FormattedMessage id="payment.pay.now.amount" />
				) : (
					<FormattedMessage id="payment.pay.all" />
				)}
				<span>
					<Amount value={payNowAmount} />
				</span>
			</Typography>
			{payLaterAmount > 0 && (
				<Typography
					variant={TYPOGRAPHY_VARIANTS.REGULAR}
					isBold
					className="creditcard-payment-type__pay-amount"
				>
					<FormattedMessage
						id="payment.pay.later.amount"
						values={{
							dueDate: (
								<FormattedDate
									timeZone="UTC"
									day="2-digit"
									month="2-digit"
									year="numeric"
									value={dueDate}
								/>
							),
						}}
					/>
					<span>
						<Amount value={payLaterAmount} />
					</span>
				</Typography>
			)}
			<CreditCardFieldsetContainer
				onBlur={onCreditCardInputsBlur}
				showAmountToPay={showAmountToPay}
				isAdyenFlow={isAdyenFlow}
				onAdyenComponentMounted={onAdyenComponentMounted}
				onAdyenAdditionalDetails={onAdyenAdditionalDetails}
				onSubmit={onCreditCardSubmit}
			/>
		</div>
	);
};

CreditCardPaymentType.propTypes = {
	payNowAmount: PropTypes.number,
	onAdyenComponentMounted: PropTypes.func,
	onCreditCardSubmit: PropTypes.func,
	onAdyenAdditionalDetails: PropTypes.func,
	payLaterAmount: PropTypes.number,
	dueDate: PropTypes.number,
	onCreditCardInputsBlur: PropTypes.func,
	isAdyenFlow: PropTypes.bool,
	showAmountToPay: PropTypes.bool,
};

export default CreditCardPaymentType;
